(function () {
  var initializedSections = new WeakSet();

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return value.replace(/"/g, '\\"');
  }

  function triggerCollectionQuickAdd(productId) {
    if (!productId) return false;

    var card = document.querySelector(".product-card-wrapper[data-id='" + escapeSelector(productId) + "']");
    var quickAddButton = card ? card.querySelector('.quick-add button') : null;

    if (!quickAddButton) return false;

    // 鼠标垫定制插件挂在集合产品卡的 quick add 中，这里复用集合页原按钮打开弹窗。
    quickAddButton.click();
    return true;
  }

  function lockTriggerButton(button) {
    if (!button || button.classList.contains('is-loading')) return false;

    // 点击后锁定 2.5 秒，防止用户连续点击重复触发集合页 quick add。
    button.classList.add('is-loading');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');

    window.setTimeout(function () {
      button.classList.remove('is-loading');
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }, 2500);

    return true;
  }

  function initSection(section) {
    if (!section || initializedSections.has(section)) return;
    initializedSections.add(section);

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-print-mousepad-quick-add-trigger]');
      if (!trigger || !section.contains(trigger)) return;

      event.preventDefault();

      if (!lockTriggerButton(trigger)) return;

      // 通过产品 id 找到 main-collection-product-grid 中同产品卡片的 quick add 按钮并触发。
      triggerCollectionQuickAdd(trigger.getAttribute('data-product-id'));
    });
  }

  function initAll() {
    document.querySelectorAll('[data-print-mousepad]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-print-mousepad]')) {
      initSection(event.target.querySelector('[data-print-mousepad]'));
    }
  });
})();
